import axios from 'utils/bsac-api.js';

const state = {
  questions: null,
};

const getters = {
  /**
   * メディカルチェック回答を返す
   * @param {*} state
   * @param {*} getters
   * @returns
   */
  answers: (state, getters) => {
    let answers = [];
    // メインセクションの回答をセットする
    getters.mainSection.questions.forEach((question) => {
      answers.push({ question_id: question.question_id, answer: question.answer });
    });

    // サブセクションの回答をセットする
    getters.subSections.forEach((section) => {
      section.questions.forEach((question) => {
        answers.push({ question_id: question.question_id, answer: question.answer });
      });
    });

    let answer = {};
    answer.version = state.questions.version;
    answer.answers = answers;
    return answer;
  },
  /**
   * サブセクションの表示可否を判定する
   * @param {*} state
   * @returns
   */
  isShowSubQuestions: (state, getters) => {
    let result = true;
    getters.mainSection.questions.forEach((question) => {
      result &= question.answer !== '';
    });
    return result;
  },
  /**
   *
   * @param {*} state
   * @returns
   */
  questions: (state) => state.questions,
  /**
   * メインセクションを取得する
   * @param {*} state
   * @returns
   */
  mainSection: (state) => {
    let mainSection = null;
    if (state.questions === null) return mainSection;
    state.questions.sections.forEach((section) => {
      if (section !== null && section.section_id === 0) mainSection = section;
    });
    return mainSection;
  },
  /**
   * ドクターチェックの必要可否を取得する
   * @param {*} state
   * @param {*} getters
   */
  requireDoctorCheck: (state, getters) => {
    let require = false;

    // メインセクションの検証
    getters.mainSection.questions.forEach((question) => {
      if (require) return;
      if (question.answer === 'はい' && question.doctor_check_required) require = true;
    });

    // サブセクションの検証
    getters.subSections.forEach((section) => {
      section.questions.forEach((question) => {
        if (require) return;
        if (question.answer === 'はい' && question.doctor_check_required) require = true;
      });
    });

    return require;
  },
  /**
   * サブセクションを取得する
   * @param {*} state
   * @returns
   */
  subSections: (state) => {
    let subSections = [];
    state.questions.sections.forEach((section) => {
      if (section !== null && section.section_id > 0) subSections.push(section);
    });
    return subSections;
  },
  /**
   * 表示用サブセクションを取得する
   * @param {*} state
   * @returns
   */
  subSectionsForDisplay: (state, getters) => {
    let subSections = [];
    if (!getters.isShowSubQuestions) return subSections;
    subSections = getters.subSections;
    getters.mainSection.questions.forEach((question) => {
      let i = -1;
      switch (question.question_id) {
        case 10001: // A欄
          i = 0;
          break;
        case 10002: // B欄
          i = 1;
          break;
        case 10004: // C欄
          i = 2;
          break;
        case 10006: // D欄
          i = 3;
          break;
        case 10007: // E欄
          i = 4;
          break;
        case 10008: // F欄
          i = 5;
          break;
        case 10009: // G欄
          i = 6;
          break;
        default:
          break;
      }
      if (i > -1) subSections[i].visible = question.answer === 'はい';
    });
    // console.log(JSON.stringify(subSections));
    return subSections;
  },
  /**
   * 入力検証メッセージを取得する
   * @param {*} state
   * @param {*} getters
   */
  validationMessage: (state, getters) => {
    let message = null;
    let result = true;

    // メインセクションの検証
    getters.mainSection.questions.forEach((question) => {
      result &= question.answer !== '';
    });
    if ((message === null) & !result) {
      message = 'No.1〜No.10の質問にすべてご回答ください';
    }

    // サブセクションの検証
    getters.mainSection.questions.forEach((question) => {
      if (question.answer !== 'はい') return;
      getters.subSections.forEach((section) => {
        if (message) return;
        if (section.sign !== question.sub_section_sign) return;
        section.questions.forEach((subQuestion) => {
          //console.log(section.sign + ':' + subQuestion.question_id + ':' + subQuestion.answer);
          result &= subQuestion.answer !== '';
          if (!result) message = section.sign + '欄の質問にすべてご回答ください';
        });
      });
    });

    return message;
  },
};

const mutations = {
  /**
   * ストアを初期化する
   * @param {*} state
   */
  reset(state) {
    state.questions = {};
  },
  /**
   * メディカルチェック質問をセットする
   * @param {*} state
   * @param {*} questions
   */
  setQuestions(state, questions) {
    state.questions = questions;
    //console.log(JSON.stringify(state.questions));
  },
};

const actions = {
  /**
   * APIを呼び出しメディカルチェック質問を取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getQuestions({ commit }) {
    return axios
      .get(process.env.FRONT_URL + '/elearning/medical_questions')
      .then((response) => {
        //console.debug('response:' + JSON.stringify(response));
        commit('setQuestions', response.data.data);
        return {
          success: true,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
